/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import Grid from '@material-ui/core/Grid';
import {
  canExpand,
  // descriptionId,
  getTemplate,
  getUiOptions,
  // titleId,
} from '@rjsf/utils';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import Button from '../../common/Button';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(1),
    color: theme.palette.mainText,
  },
}));

const ObjectFieldTemplate = ({
  description,
  title,
  properties,
  required,
  disabled,
  readonly,
  uiSchema,
  idSchema,
  schema,
  formData,
  onAddClick,
  registry,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const uiOptions = getUiOptions(uiSchema);
  const TitleFieldTemplate = getTemplate('TitleFieldTemplate', registry, uiOptions);
  const DescriptionFieldTemplate = getTemplate('DescriptionFieldTemplate', registry, uiOptions);
  // const { ButtonTemplates: { AddButton } } = registry.templates;

  return (
    <>
      {(uiOptions.title || (title != null && title.length > 0)) && (
        <TitleFieldTemplate
          id={`${idSchema.$id}-title`}
          title={title}
          variant={uiSchema['ui:variantTitle']}
          required={required}
          uiSchema={uiSchema}
          registry={registry}
        />
      )}

      {(uiOptions.description || description) && (
        <DescriptionFieldTemplate
          id={`${idSchema.$id}-description`}
          variant={uiSchema['ui:variantDescription']}
          description={uiOptions.description || description}
          schema={schema}
          uiSchema={uiSchema}
          registry={registry}
        />
      )}
      <Grid container={true} spacing={2} className={classes.root}>
        {properties.map((element, index) =>
          // Remove the <Grid> if the inner element is hidden as the <Grid>
          // itself would otherwise still take up space.
          element.hidden ? (
            element.content
          ) : (
            <Grid item={true} xs={12} key={index}>
              {element.content}
            </Grid>
          ),
        )}
        {canExpand(schema, uiSchema, formData) && (
          <Grid container justifyContent="flex-end">
            <Grid item={true}>
              <Button
                variant="text"
                className="object-property-expand"
                color="default"
                onClick={onAddClick(schema)}
                disabled={disabled || readonly}
                uiSchema={uiSchema}
                registry={registry}
              >
                {t('Add')}
              </Button>
            </Grid>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default ObjectFieldTemplate;
